import "../../styles/movie-table.scss";
import { Link } from "react-router-dom";

const UpNext = () => {
  return (
    <div id="root" className="up-next-page">
      <h1 style={{ textAlign: "center" }}>Up Next!</h1>
      <div className="up-next-content">
        <a href="#LINK" className="up-next-link">Up Next</a>
      </div>
      <div style={{ textAlign: "center", marginTop: "2rem" }}>
        <Link to="/movie-night">Back to Movie List</Link>
      </div>
    </div>
  );
};

export default UpNext;
